import * as turf from "@turf/turf";
import type { Station } from "./types";
import stationsData from "../public/data/stations.json";

export const ZONE_RADIUS_MILES = 0.25;

export const STATIONS: Station[] = stationsData as Station[];

/** Stable numeric id per station, used for MapLibre feature-state. */
export const STATION_INDEX: Record<string, number> = Object.fromEntries(
  STATIONS.map((s, i) => [s.id, i])
);

export const STATION_BY_ID: Record<string, Station> = Object.fromEntries(
  STATIONS.map((s) => [s.id, s])
);

/** ¼-mile geodesic circle polygon for one station (to scale at any zoom). */
export function zonePolygon(s: Station) {
  return turf.circle([s.lng, s.lat], ZONE_RADIUS_MILES, {
    units: "miles",
    steps: 48,
  });
}

/** FeatureCollection of all zone polygons, keyed by numeric feature id. */
export function zoneFeatureCollection(): GeoJSON.FeatureCollection {
  return {
    type: "FeatureCollection",
    features: STATIONS.map((s, i) => {
      const poly = zonePolygon(s);
      poly.id = i;
      poly.properties = { id: s.id, name: s.name };
      return poly as GeoJSON.Feature;
    }),
  };
}

/** FeatureCollection of station center points. */
export function dotFeatureCollection(): GeoJSON.FeatureCollection {
  return {
    type: "FeatureCollection",
    features: STATIONS.map((s, i) => ({
      type: "Feature",
      id: i,
      geometry: { type: "Point", coordinates: [s.lng, s.lat] },
      properties: { id: s.id, name: s.name, routes: s.routes.join(" ") },
    })),
  };
}
